export type Review = {
  quote: string
  name: string
  role: string
  city: string
  country: string
}

/**
 * Vacío a propósito: la sección de reseñas solo se muestra con reseñas reales
 * de compradores del DPS64. Cargalas acá (nombre, rol, ciudad, país) y la
 * sección aparece sola.
 */
export const reviews: Review[] = []
